// extracted by mini-css-extract-plugin
export default {"tableTitle":"credentials-location-title_tableTitle__zuzqv","tableLogo":"credentials-location-title_tableLogo__oUrR5"};